import Swiper from "swiper";
import { Keyboard } from "swiper/modules";

const reduceMotion = window.matchMedia("(prefers-reduced-motion: reduce)");
const tablet = window.matchMedia("(min-width: 768px)");

document.querySelectorAll(".swiper_stories-layout").forEach((layout) => {
	const slider = layout.querySelector(".stories-swiper");
	if (!slider) return;

	// De PHP herhaalt de verhalen voor de loop; de dots horen bij de echte verhalen (data-story).
	const names = [];
	slider.querySelectorAll(".swiper-slide").forEach((slide) => {
		names[slide.dataset.story] ??= slide.querySelector(".story-slide-link")?.getAttribute("aria-label") ?? "";
	});

	const dots = layout.querySelector(".pk-pagination");
	const bullets = names.map((name, i) => {
		const bullet = document.createElement("button");
		bullet.type = "button";
		bullet.className = "swiper-pagination-bullet";
		bullet.setAttribute("aria-label", name);
		dots?.append(bullet);
		return bullet;
	});

	const syncDots = (swiper) => {
		const current = Number(swiper.slides[swiper.activeIndex]?.dataset.story);
		bullets.forEach((bullet, i) => {
			bullet.classList.toggle("swiper-pagination-bullet-active", i === current);
			bullet.toggleAttribute("aria-current", i === current);
		});
	};

	// Figma: de kaarten staan gecentreerd, op desktop twee naast elkaar rond het midden en op mobiel één. De rest loopt buiten de randen door.
	// De offset moet al bij het aanmaken kloppen, anders vult de loop links geen slides aan. De slide is breder dan de kaart (de tussenruimte zit als padding in de slide), dus de offset is gewoon de helft van wat overblijft.
	const offsetBefore = (width, slideWidth) => Math.max(0, (width - (tablet.matches ? 2 : 1) * slideWidth) / 2);

	const swiper = new Swiper(slider, {
		modules: [Keyboard],
		slidesPerView: "auto",
		slidesOffsetBefore: offsetBefore(slider.clientWidth, slider.querySelector(".swiper-slide").offsetWidth),
		loop: true,
		loopAdditionalSlides: 2,
		grabCursor: true,
		speed: reduceMotion.matches ? 0 : 600,
		keyboard: { enabled: true, onlyInViewport: true },
		on: {
			init: syncDots,
			resize: (s) => {
				s.params.slidesOffsetBefore = offsetBefore(s.width, s.slides[0].offsetWidth);
				s.update();
			},
			slideChange: syncDots,
		},
	});

	// Naar de dichtstbijzijnde slide van het gekozen verhaal.
	bullets.forEach((bullet, i) =>
		bullet.addEventListener("click", () => {
			const nearest = swiper.slides
				.filter((slide) => Number(slide.dataset.story) === i)
				.sort((a, b) => Math.abs(swiper.slides.indexOf(a) - swiper.activeIndex) - Math.abs(swiper.slides.indexOf(b) - swiper.activeIndex))[0];
			if (nearest) swiper.slideToLoop(Number(nearest.dataset.swiperSlideIndex));
		}),
	);

	// Het snippet op de videokaart speelt alleen zolang de muis of de focus erop staat.
	if (!reduceMotion.matches) {
		slider.addEventListener("pointerenter", (event) => toggleSnippet(event.target, true), true);
		slider.addEventListener("pointerleave", (event) => toggleSnippet(event.target, false), true);
		slider.addEventListener("focusin", (event) => toggleSnippet(event.target, true));
		slider.addEventListener("focusout", (event) => toggleSnippet(event.target, false));
	}
});

export function toggleSnippet(target, play) {
	const card = target.closest?.(".story-slide--video");
	const video = card?.querySelector(".story-slide-video");
	if (!video) return;

	if (play) {
		loadSnippet(video);
		video.play().then(() => video.classList.add("is-playing")).catch(() => {});
	} else {
		video.pause();
		video.currentTime = 0;
		video.classList.remove("is-playing");
	}
}

// De bronnen worden pas bij de eerste hover aangemaakt; daarvoor downloadt de pagina niets van het snippet.
function loadSnippet(video) {
	if (video.dataset.loaded) return;
	video.dataset.loaded = "true";

	[["webm", "video/webm"], ["mp4", "video/mp4"]].forEach(([key, type]) => {
		if (!video.dataset[key]) return;
		const source = document.createElement("source");
		source.src = video.dataset[key];
		source.type = type;
		video.append(source);
	});
	video.load();
}

// De volledige video laadt als de dialog opent en stopt als hij sluit (de events komen uit dialogs.js van de parent).
document.addEventListener("dialog:open", (event) => {
	const video = event.detail.dialog.querySelector("video[data-src]");
	if (!video) return;

	// De dialog neemt de verhouding van de video aan, zodat de video hem helemaal vult.
	video.addEventListener("loadedmetadata", () => video.parentElement.style.setProperty("--video-ratio", video.videoWidth / video.videoHeight), { once: true });
	video.src = video.dataset.src;
	video.play().catch(() => {});
});

document.addEventListener("dialog:close", (event) => {
	const video = event.detail.dialog.querySelector("video[data-src]");
	if (!video) return;

	video.pause();
	video.removeAttribute("src");
	video.load();
});
